module.exports = __webpack_public_path__ + "media/images/features/modification/thumb-voice-3-5c2281c5c710af18740bc90e8f2ae690.jpg";